<div class="booking-management unavailable" *ngIf="!featureAvailable">
  <div class="empty-state">
    <i class="material-icons">block</i>
    <h2>Booking Management is currently unavailable</h2>
    <p>{{ errorMessage || 'This feature is not available for your operator organisation.' }}</p>
    <a class="btn btn-primary" routerLink="/dashboard">Return to dashboard</a>
  </div>
</div>
<div class="booking-management" *ngIf="featureAvailable">
  <div class="page-header">
    <h1>{{ getPageTitle() }}</h1>
    <div class="header-actions">
      <button class="btn btn-primary" routerLink="/dashboard/search">
        <i class="material-icons">search</i>
        Find Available Trips
      </button>
      <button class="btn btn-secondary" *ngIf="canManageBookings()" (click)="exportToCSV()" [disabled]="filteredBookings.length === 0">
        <i class="material-icons">download</i>
        Export CSV
      </button>
      <button class="btn btn-secondary" (click)="refreshData()">
        <i class="material-icons">refresh</i>
        Refresh
      </button>
    </div>
  </div>

  <div class="alert alert-error" *ngIf="errorMessage">
    <i class="material-icons">error</i>
    {{ errorMessage }}
  </div>

  <div class="alert alert-success" *ngIf="successMessage">
    <i class="material-icons">check_circle</i>
    {{ successMessage }}
  </div>

  <!-- Filters -->
  <div class="filters-section">
    <div class="filter-controls">
      <div class="filter-group">
        <label>Status</label>
        <select class="form-control" [(ngModel)]="statusFilter" (ngModelChange)="filterBookings()">
          <option value="">All Statuses</option>
          <option *ngFor="let status of statusOptions" [value]="status">
            {{ status | titlecase }}
          </option>
        </select>
      </div>
      
      <div class="filter-group">
        <label>Date</label>
        <input type="date" class="form-control" [(ngModel)]="dateFilter" 
               (ngModelChange)="filterBookings()">
      </div>
      
      <div class="filter-group">
        <label>Search</label>
        <input type="text" class="form-control" placeholder="Search bookings..." 
               [(ngModel)]="searchFilter" (ngModelChange)="filterBookings()">
      </div>
      
      <div class="filter-group">
        <label>&nbsp;</label>
        <button class="btn btn-clear" (click)="clearFilters()" 
                [disabled]="!statusFilter && !dateFilter && !searchFilter">
          <i class="material-icons">clear</i>
          Clear Filters
        </button>
      </div>
    </div>
  </div>

  <!-- Bookings Summary -->
  <div class="bookings-summary" *ngIf="isReadOnlyBookingView() && !isLoading">
    <div class="summary-card">
      <div class="summary-icon confirmed">
        <i class="material-icons">event_available</i>
      </div>
      <div class="summary-content">
        <h3>{{ getUpcomingTripCount() }}</h3>
        <p>Upcoming Trips</p>
      </div>
    </div>

    <div class="summary-card">
      <div class="summary-icon pending">
        <i class="material-icons">history</i>
      </div>
      <div class="summary-content">
        <h3>{{ getPastTripCount() }}</h3>
        <p>Past Trips</p>
      </div>
    </div>

    <div class="summary-card">
      <div class="summary-icon revenue">
        <i class="material-icons">confirmation_number</i>
      </div>
      <div class="summary-content">
        <h3>{{ getTicketAvailableCount() }}</h3>
        <p>E-tickets</p>
      </div>
    </div>

    <div class="summary-card">
      <div class="summary-icon total">
        <i class="material-icons">business</i>
      </div>
      <div class="summary-content">
        <h3>{{ getOperatorCount() }}</h3>
        <p>Operators Used</p>
      </div>
    </div>
  </div>

  <div class="bookings-summary" *ngIf="canManageBookings()">
    <div class="summary-card">
      <div class="summary-icon confirmed">
        <i class="material-icons">check_circle</i>
      </div>
      <div class="summary-content">
        <h3>{{ getCountByStatus(bookingStatusEnum.CONFIRMED) }}</h3>
        <p>Confirmed Bookings</p>
      </div>
    </div>
    
    <div class="summary-card">
      <div class="summary-icon pending">
        <i class="material-icons">pending</i>
      </div>
      <div class="summary-content">
        <h3>{{ getCountByStatus(bookingStatusEnum.PENDING) }}</h3>
        <p>Pending Bookings</p>
      </div>
    </div>
    
    <div class="summary-card">
      <div class="summary-icon revenue">
        <i class="material-icons">payments</i>
      </div>
      <div class="summary-content">
        <h3>R {{ getTotalRevenue() | number:'1.2-2' }}</h3>
        <p>Total Revenue</p>
      </div>
    </div>
    
    <div class="summary-card">
      <div class="summary-icon total">
        <i class="material-icons">list_alt</i>
      </div>
      <div class="summary-content">
        <h3>{{ filteredBookings.length }}</h3>
        <p>Filtered Bookings</p>
      </div>
    </div>
  </div>

  <!-- Bookings Table -->
  <div class="loading-state" *ngIf="isLoading">
    <i class="material-icons">sync</i>
    <span>Loading bookings...</span>
  </div>

  <div class="role-booking-sections" *ngIf="isReadOnlyBookingView() && !isLoading">
    <section class="booking-card-section">
      <div class="section-heading">
        <div>
          <p class="eyebrow">Upcoming</p>
          <h3>{{ getUpcomingBookings().length }} booking{{ getUpcomingBookings().length === 1 ? '' : 's' }}</h3>
        </div>
      </div>

      <div class="booking-card-grid" *ngIf="getUpcomingBookings().length; else noUpcomingBookings">
        <article class="booking-card" *ngFor="let booking of getUpcomingBookings()">
          <div class="booking-card-header">
            <strong>{{ booking.bookingReference || ('#' + booking.bookingID) }}</strong>
            <span class="status-badge" [ngStyle]="{'background-color': getStatusColor(getBookingStatus(booking))}">
              {{ getStatusLabel(booking) }}
            </span>
          </div>
          <h3>{{ getTripName(booking) }}</h3>
          <p class="operator-line">
            <img *ngIf="getOperatorLogo(booking)" [src]="getOperatorLogo(booking)" [alt]="getOperatorName(booking) + ' logo'">
            <i class="material-icons" *ngIf="!getOperatorLogo(booking)">business</i>
            {{ getOperatorName(booking) }}
          </p>
          <div class="booking-card-meta">
            <span><i class="material-icons">schedule</i>{{ getTripDate(booking) | date:'medium' }}</span>
            <span><i class="material-icons">flag</i>{{ getTripEndDate(booking) | date:'shortTime' }}</span>
            <span><i class="material-icons">event_seat</i>{{ getSeatCount(booking) }} seat{{ getSeatCount(booking) === 1 ? '' : 's' }}</span>
          </div>
          <dl>
            <div>
              <dt>Seat numbers</dt>
              <dd>{{ getSeatNumbersLabel(booking) }}</dd>
            </div>
            <div>
              <dt>Payment</dt>
              <dd>{{ getPaymentLabel(booking) }}</dd>
            </div>
            <div>
              <dt>E-ticket</dt>
              <dd>{{ getTicketAvailabilityLabel(booking) }}</dd>
            </div>
            <div>
              <dt>Passenger</dt>
              <dd>{{ getPassengerName(booking) }}</dd>
            </div>
            <div *ngIf="shouldShowPassengerContact()">
              <dt>Contact</dt>
              <dd>{{ getPassengerContact(booking) }}</dd>
            </div>
          </dl>
          <div class="booking-card-actions">
            <a class="primary-action" *ngIf="getTicketUrl(booking)" [href]="getTicketUrl(booking)" target="_blank" rel="noopener">
              <i class="material-icons">confirmation_number</i>
              Open e-ticket
            </a>
            <span class="proof-note" *ngIf="!getTicketUrl(booking)">Use this reference as proof of reservation.</span>
          </div>
        </article>
      </div>

      <ng-template #noUpcomingBookings>
        <div class="empty-state compact">
          <i class="material-icons">event_available</i>
          <h3>No upcoming bookings</h3>
          <p *ngIf="!isDriver">Search for a trip when you are ready to reserve seats.</p>
          <p *ngIf="isDriver">No assigned trip bookings are coming up.</p>
        </div>
      </ng-template>
    </section>

    <section class="booking-card-section" *ngIf="getPastBookings().length">
      <div class="section-heading">
        <div>
          <p class="eyebrow">Past</p>
          <h3>{{ getPastBookings().length }} booking{{ getPastBookings().length === 1 ? '' : 's' }}</h3>
        </div>
      </div>
      <div class="booking-card-grid">
        <article class="booking-card quiet" *ngFor="let booking of getPastBookings()">
          <div class="booking-card-header">
            <strong>{{ booking.bookingReference || ('#' + booking.bookingID) }}</strong>
            <span class="status-badge" [ngStyle]="{'background-color': getStatusColor(getBookingStatus(booking))}">
              {{ getStatusLabel(booking) }}
            </span>
          </div>
          <h3>{{ getTripName(booking) }}</h3>
          <p class="operator-line">
            <img *ngIf="getOperatorLogo(booking)" [src]="getOperatorLogo(booking)" [alt]="getOperatorName(booking) + ' logo'">
            <i class="material-icons" *ngIf="!getOperatorLogo(booking)">business</i>
            {{ getOperatorName(booking) }}
          </p>
          <div class="booking-card-meta">
            <span><i class="material-icons">schedule</i>{{ getTripDate(booking) | date:'medium' }}</span>
            <span><i class="material-icons">event_seat</i>{{ getSeatCount(booking) }} seat{{ getSeatCount(booking) === 1 ? '' : 's' }}</span>
          </div>
          <dl>
            <div>
              <dt>Seat numbers</dt>
              <dd>{{ getSeatNumbersLabel(booking) }}</dd>
            </div>
            <div>
              <dt>Payment</dt>
              <dd>{{ getPaymentLabel(booking) }}</dd>
            </div>
            <div>
              <dt>E-ticket</dt>
              <dd>{{ getTicketAvailabilityLabel(booking) }}</dd>
            </div>
            <div>
              <dt>Rating</dt>
              <dd class="future-note">Trip rating coming soon</dd>
            </div>
          </dl>
          <div class="booking-card-actions">
            <a class="primary-action" *ngIf="getTicketUrl(booking)" [href]="getTicketUrl(booking)" target="_blank" rel="noopener">
              <i class="material-icons">confirmation_number</i>
              Open e-ticket
            </a>
          </div>
        </article>
      </div>
    </section>
  </div>

  <div class="bookings-table-container" *ngIf="canManageBookings() && !isLoading">
    <div class="table-header">
      <h3>Bookings ({{ filteredBookings.length }} found)</h3>
      <div class="table-actions">
        <span *ngIf="statusFilter || dateFilter || searchFilter" class="filter-info">
          Filters applied: 
          <span *ngIf="statusFilter">Status: {{ statusFilter | titlecase }}</span>
          <span *ngIf="dateFilter">, Date: {{ dateFilter | date }}</span>
          <span *ngIf="searchFilter">, Search: "{{ searchFilter }}"</span>
        </span>
      </div>
    </div>
    
    <div class="table-responsive" *ngIf="filteredBookings.length > 0">
      <table class="bookings-table">
        <thead>
          <tr>
            <th>Booking ID</th>
            <th>Trip Details</th>
            <th>Passenger</th>
            <th>Booking Date</th>
            <th>Seats</th>
            <th>Total Price</th>
            <th>Booking Status</th>
            <th>Payment Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let booking of filteredBookings">
            <td>
              #{{ booking.bookingID }}
              <small *ngIf="booking.bookingReference" class="text-muted">{{ booking.bookingReference }}</small>
            </td>
            <td>
              <strong>{{ getTripName(booking) }}</strong>
              <p class="text-muted">{{ getOperatorName(booking) }}</p>
              <p class="text-muted">
                {{ getRouteLabel(booking) }}
              </p>
              <small *ngIf="getTripDate(booking) as tripDate">
                {{ tripDate | date:'medium' }}
              </small>
            </td>
            <td>
              <strong>{{ getPassengerName(booking) }}</strong>
              <p class="text-muted">{{ getPassengerContact(booking) }}</p>
              <small>User ID: {{ booking.userID }}</small>
            </td>
            <td>{{ booking.bookingDate | date:'shortDate' }}</td>
            <td>
              <span class="seat-badge">{{ getSeatCount(booking) }}</span>
            </td>
            <td>
              <strong>R {{ getBookingTotal(booking) | number:'1.2-2' }}</strong>
              <p class="text-muted">{{ booking.paymentMethod || 'Not specified' }}</p>
            </td>
            <td>
              <div class="status-container">
                <span class="status-badge" [ngStyle]="{'background-color': getStatusColor(getBookingStatus(booking))}">
                  {{ getStatusLabel(booking) }}
                </span>
                <!-- Use the method with typed event -->
                <select class="status-select" 
                        (change)="onStatusChange(booking.bookingID, $event)">
                  <option *ngFor="let status of statusOptions" [value]="status" 
                          [selected]="status === getBookingStatus(booking)">
                    {{ status | titlecase }}
                  </option>
                </select>
              </div>
            </td>
            <td>
              <div class="status-container">
                <span class="payment-badge" [ngStyle]="{'background-color': getPaymentStatusColor(booking.paymentStatus)}">
                  {{ getPaymentLabel(booking) }}
                </span>
                <!-- Use the method with typed event -->
                <select class="status-select" 
                        (change)="onPaymentStatusChange(booking.bookingID, $event)">
                  <option *ngFor="let status of paymentStatusOptions" [value]="status" 
                          [selected]="status === booking.paymentStatus">
                    {{ status | titlecase }}
                  </option>
                </select>
              </div>
            </td>
            <td class="actions-cell">
              <button class="btn-icon" (click)="printTicket(booking)" title="Print Ticket">
                <i class="material-icons">print</i>
              </button>
              <button class="btn-icon" (click)="sendConfirmationEmail(booking)" title="Send Confirmation Email">
                <i class="material-icons">email</i>
              </button>
              <button class="btn-icon" [routerLink]="['/dashboard/trips', booking.tripID]" title="View Trip">
                <i class="material-icons">visibility</i>
              </button>
              <a class="btn-icon" *ngIf="getTicketUrl(booking)" [href]="getTicketUrl(booking)" target="_blank" rel="noopener" title="Open e-ticket">
                <i class="material-icons">confirmation_number</i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="empty-state" *ngIf="filteredBookings.length === 0 && !isLoading">
      <i class="material-icons">book_online</i>
      <h3>No bookings found</h3>
      <p *ngIf="statusFilter || dateFilter || searchFilter">
        Try changing your filters or 
        <a href="#" (click)="clearFilters(); $event.preventDefault()">clear all filters</a>
      </p>
      <p *ngIf="!statusFilter && !dateFilter && !searchFilter">
        No bookings have been made yet.
      </p>
      <button class="btn btn-primary" routerLink="/dashboard/search">
        Find Trips to Book
      </button>
    </div>
  </div>
</div>
